import { DrawerDirection } from './types';

export function set(
  element: HTMLElement | null,
  styles: Partial<CSSStyleDeclaration>,
  reset = false,
) {
  if (!element) return;

  Object.keys(styles).forEach((property) => {
    if (reset) {
      element.style.removeProperty(property);
    } else {
      element.style.setProperty(property, styles[property as keyof CSSStyleDeclaration] as string);
    }
  });
}

export function getTranslate(element: HTMLElement, direction: DrawerDirection) {
  const style = window.getComputedStyle(element);
  const matrix = new WebKitCSSMatrix(style.transform);

  if (direction === 'bottom' || direction === 'top') return matrix.m42;
  return matrix.m41;
}

export function dampenValue(value: number) {
  return value * 0.15;
}

export function isVertical(direction: DrawerDirection) {
  return direction === 'top' || direction === 'bottom';
}

export function reset(element: HTMLElement, property: string) {
  element.style.removeProperty(property);
}
